import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from "@angular/common/http";
import { NgbActiveModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import {
  GlobalsService,
  AuthInterceptor,
  ToolboxService,
} from "./shared/services";

import { LoadingService } from "./shared/components";
import { AngularFontAwesomeModule } from "angular-font-awesome";
import { SharedModule } from "./shared/shared.module";
import { ClickOutsideModule } from "ng-click-outside";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { RouterModule } from "@angular/router";
import { routes } from "./pages/evaluations/evaluations-routing.module";
import { EvaluationsModule } from "./pages/evaluations/evaluations.module";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularFontAwesomeModule,
    SharedModule,
    NgbModule,
    ClickOutsideModule,
    EvaluationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    RouterModule.forRoot(routes, { onSameUrlNavigation: "ignore" }),
    LoadingBarRouterModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    GlobalsService,
    ToolboxService,
    NgbActiveModal,
    LoadingService,
  ],
  exports: [RouterModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
